import { useContext } from 'react'
import { LanguageContext } from './context'
import type { LanguageValue } from './context'

export function useLanguage(): LanguageValue {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useLanguage must be used inside <LanguageProvider>')
  return ctx
}

/** Shorthand for the common case of only needing the translate function. */
export function useT() {
  return useLanguage().t
}
